module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(" Grade Calculator ")]), _vm._v(" "), _c('div', {
    staticClass: "buttonNav"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.goToPage('Cummulative')
      }
    }
  }, [_vm._v("Cummulative")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.goToPage('Weight')
      }
    }
  }, [_vm._v("Weight")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.goToPage('GPA')
      }
    }
  }, [_vm._v("GPA")])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b76235e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 25
// module chunks = 0